import type { AsyncThunk } from '@reduxjs/toolkit';
import { getBaseUrl, request } from 'src/helpers/thunkApi';

interface ThunkRejectValue {
  actionType?: string;
  status?: number;
  [key: string]: unknown;
}

type RequestThunk = AsyncThunk<unknown, unknown, { rejectValue: ThunkRejectValue }>;

export const fetchFlagSummary = (signal?: AbortSignal): RequestThunk => request(
  {
    method: 'GET',
    url: `${getBaseUrl()}/api/flags/summary`,
    contentType: 'json',
    signal,
  },
  'flag-summary',
);
